'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from '~/modules/trpc/client';
import { useActivityAiChatStore } from './activity-ai-chat-store';
import { removeChatFromRegistry } from './useActivityAiChat';

/**
 * Loads the Postgres chat list into the in-memory store (FUN-4637). Mount ONCE
 * near the AI Search feature root.
 */
export function useAiChatHistorySync() {
  const $ = _c(6);
  const trpc = useTRPC();
  const hydrateServerThreads = useActivityAiChatStore(_temp);
  let t0;
  if ($[0] !== trpc.aiChat.list) {
    t0 = trpc.aiChat.list.queryOptions();
    $[0] = trpc.aiChat.list;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listQuery = useQuery(t0);
  let t1;
  let t2;
  if ($[2] !== hydrateServerThreads || $[3] !== listQuery.data) {
    t1 = () => {
      if (!listQuery.data) {
        return;
      }
      hydrateServerThreads(listQuery.data.map(_temp2));
    };
    t2 = [listQuery.data, hydrateServerThreads];
    $[2] = hydrateServerThreads;
    $[3] = listQuery.data;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
}

/** Delete a chat from Postgres + clear all local caches. */
function _temp2(row) {
  return {
    id: row.id,
    title: row.title,
    createdAt: new Date(row.createdAt).getTime()
  };
}
function _temp(s) {
  return s.hydrateServerThreads;
}
export function useDeleteAiSearchChat() {
  const $ = _c(7);
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const deleteThread = useActivityAiChatStore(_temp3);
  let t0;
  if ($[0] !== trpc.aiChat.delete) {
    t0 = trpc.aiChat.delete.mutationOptions();
    $[0] = trpc.aiChat.delete;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const deleteMutation = useMutation(t0);
  let t1;
  if ($[2] !== deleteMutation || $[3] !== deleteThread || $[4] !== queryClient || $[5] !== trpc.aiChat.list) {
    t1 = chatId => {
      deleteThread(chatId);
      removeChatFromRegistry(chatId);
      deleteMutation.mutate({
        id: chatId
      }, {
        onSettled: () => queryClient.invalidateQueries({
          queryKey: trpc.aiChat.list.queryKey()
        })
      });
    };
    $[2] = deleteMutation;
    $[3] = deleteThread;
    $[4] = queryClient;
    $[5] = trpc.aiChat.list;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function _temp3(s) {
  return s.deleteThread;
}